import { all, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../admincore'

import { getInvites } from '../../api'
import actions, { load } from './actions'

// const getCompanySelect = state => state.companySelect

let cachedParams = null

function* LOAD({ payload: { params } }) {
  cachedParams = params
  // const companySelect = yield select(getCompanySelect)
  const companySelect = localStorage.getItem('app.settings.company')

  if (!companySelect || companySelect === -1) {
    return
  }

  yield put(request(getInvites(companySelect, params), actions.LOAD))
}

function* REFRESH() {
  if (cachedParams) {
    yield put(load(cachedParams))
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, LOAD),
    takeEvery('company/save', REFRESH),
    takeEvery('invites/create/success', REFRESH),
    takeEvery('invites/destroy/success', REFRESH),
    takeEvery('invites/update/success', REFRESH),
  ])
}
